import React from "react";
import { View, Text, StyleSheet, ScrollView, Image } from "react-native";
import { useTranslation } from "../../../../i18n/useTranslation";
import { useSessionStore } from "../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../state/src/useSessionStore";
import PinIllustrationIcon from "../../../../../../../assets/images/PinIllustration.svg";
import ApplApsskeyIcon from "../../../../../../../assets/images/Apple-Apsskey-icon.svg";
import Colors from "../../../../constants/colors";

type Props = {
  testID?: string;
};

export default function ConfirmationStep({ testID }: Props) {
  const { t } = useTranslation();
  const isReceiver = useSessionStore((s: SessionState) => (s as any).isReceiver);
  const isSendCash = useSessionStore((s: SessionState) => (s as any).isSendCash);

  return (
    <View
      testID={testID}
      style={styles.container}
    >
      {isReceiver ? (
        <View style={{ alignItems: 'center', paddingTop: 32}}>
          <ApplApsskeyIcon width={228} height={228}/>
          <Text style={styles.title}>{t("TELL_US_ABOUT_YOUSELF")}</Text>
          <Text style={[styles.subtitle, { paddingHorizontal: 50}]}>{t("TRANSACTION_SECURE_AND_PREVENT_FRAUD")}</Text>
        </View>
      ) : (
        <View style={{ alignItems: 'center', paddingTop: 32}}>
          <PinIllustrationIcon width={228} height={228}/>
          <Text style={styles.title}>{t("PIN_CREATED")}</Text>
          <Text style={styles.subtitle}>{t("REMEMBER_PIN")}</Text>
        </View>
      )}
    </View>
  );
}


const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
    backgroundColor: "#fff",
    alignItems: 'center'
  },
  successIconStyle: {
    marginTop: 56,
    width: 228,
    height: 228
  },
  title: {
    fontFamily: 'Inter',
    fontSize: 34,
    fontWeight: "900",
    textAlign: "center",
    color: Colors.titleTextColor,
    marginTop: 38,
    marginBottom: 8,
    lineHeight: 40,
    width: 287,
    paddingHorizontal: 20
  },
  subtitle: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    textAlign: "center",
    color: Colors.subTitleColor,
    paddingHorizontal: 24,
    lineHeight: 24
  },
});